import React, { memo, useCallback } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import Checkbox from 'Components/Forms/Elements/Checkbox';
import bemit from 'Functions/bemit';
import { isTrue } from 'Shared/utilities';
export default memo(function BookingLegalFields({
  ...props
}) {
  const cgu_accepted = BookingFormStore.useState(s => s.cgu_accepted);
  const subscribed = BookingFormStore.useState(s => s.newsletter_subscription);
  const b2b = BookingFormStore.useState(s => isTrue(s.b2b));
  const errors = BookingFormStore.useState(s => s.status_messages || {});
  const handleChange = useCallback(function ({
    e,
    value,
    name
  }) {
    BookingFormStore.update(function (store) {
      store[name] = value;
      ['info', 'error', 'warning'].forEach(field => store[field] = undefined);
    });
  }, []);
  const openCGUModal = useCallback(function (e) {
    e.persist();
    BookingFormStore.update(function (store) {
      if (b2b) {
        store.cgu_employee_modal_trigger = e?.target;
        store.cgu_employee_modal = true;
      } else {
        store.cgu_modal_trigger = e?.target;
        store.cgu_modal = true;
      }
    });
  }, [b2b]);
  const modifiers = ['custom-checkbox', 'reservation'].concat(props['white-label-booking'] ? ['white-label-booking'] : []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
    onChange: handleChange,
    className: bemit('c-form-element', modifiers.concat(['custom-checkbox'])),
    value: cgu_accepted,
    name: "cgu_accepted",
    "full-width": false,
    label: "J'ai lu et accepte les ",
    status: errors
  }, /*#__PURE__*/React.createElement("a", {
    className: bemit('c-link', ['cgu']),
    onClick: openCGUModal
  }, "conditions de vente et d'annulation")), isTrue(props['with-newsletter']) ? /*#__PURE__*/React.createElement(Checkbox, {
    onChange: handleChange,
    className: bemit('c-form-element', modifiers) + ' u-margin-bottom-0',
    value: subscribed,
    name: "newsletter_subscription",
    label: "J'accepte de recevoir des offres commerciales et/ou publicitaires de myWO par email, sms et mms.",
    "full-width": true,
    status: errors
  }) : undefined);
});
